<template>
  <div :style="containerStyle">
    <iframe
      ref="iframeRef"
      :src="src"
      :title="title"
      :style="iframeStyle"
      :loading="loadingType"
      @load="handleLoad"
      @error="handleError"
    ></iframe>
  </div>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import { iframeProps } from './iframe'

defineOptions({
  name: 'LlIframe',
})

// 定义组件属性
const props = defineProps(iframeProps)

// 定义组件事件
const emit = defineEmits(['loaded', 'error'])

const iframeRef = ref<HTMLIFrameElement | null>(null)
const loading = ref(false)
const error = ref<string | null>(null)
const timer = ref<number | null>(null)

// 容器样式
const containerStyle = computed(() => ({
  width: props.width,
  height: props.height,
  border: props.showBorder ? '1px solid var(--color-border)' : 'none',
  overflow: 'hidden',
  'border-radius': '6px',
}))

// iframe样式
const iframeStyle = computed(() => ({
  width: '100%',
  height: '100%',
  border: 'none',
  borderRadius: '6px',
}))

// 处理加载完成事件
const handleLoad = () => {
  loading.value = false
  error.value = null
  if (timer.value) {
    clearTimeout(timer.value)
    timer.value = null
  }
  emit('loaded')
}

// 处理加载错误事件
const handleError = () => {
  loading.value = false
  error.value = '无法加载页面内容'
  emit('error', error.value)
}

// 组件挂载时
onMounted(() => {
  // 设置加载超时
  timer.value = window.setTimeout(() => {
    if (loading.value) {
      handleError()
    }
  }, 10000)
})

// 组件卸载前
onBeforeUnmount(() => {
  if (timer.value) {
    clearTimeout(timer.value)
  }
})
</script>
